import { render, staticRenderFns } from "./MyUpLoad.vue?vue&type=template&id=a4ac503e&scoped=true"
import script from "./MyUpLoad.vue?vue&type=script&lang=js"
export * from "./MyUpLoad.vue?vue&type=script&lang=js"
import style0 from "./MyUpLoad.vue?vue&type=style&index=0&id=a4ac503e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ac503e",
  null
  
)

export default component.exports